import {
  MealType,
  SearchableFoodSource,
  SearchFoodResultType,
} from "model/food/types"
import { IEdamaFoodSearchResult } from "model/food/types/edama.types"
import { IMyFood } from "model/food/types/myfood.types"
import { RecentIngredientType } from "model/food/types/recentIngredient.types"

export interface ISearchFoodsPayload {
  keyword: string
  session?: string
  sources?: SearchableFoodSource[]
}

export interface IGetSuggestedSearchTexts {
  keyword: string
  getSuggestedSearchTextsLoading: boolean
  getSuggestedSearchTextsFailed: any
  suggestedSearchTexts: string[]
  isNoSuggestedSearchTexts: boolean
}

export interface ISearchFoods {
  searchFoodsResults: SearchFoodResultType[]
  searchFoodsLoading: boolean
  searchFoodsFailed: any
  searchSession: string
  noSearchedFoodFounded: boolean
}

export interface IGetExternalSuggestedSearchTexts {
  externalKeyword: string
  getExternalSuggestedSearchTextsLoading: boolean
  getExternalSuggestedSearchTextsFailed: any
  externalSuggestedSearchTexts: string[]
  isNoExternalSuggestedSearchTexts: boolean
}

export interface ISearchEdamaFoods {
  searchEdamaFoodsResults: IEdamaFoodSearchResult[]
  searchEdamaFoodsLoading: boolean
  searchEdamaFoodsFailed: any
  externalSearchSession: string
  noSearchedExternalFoodFounded: boolean
}

export interface IGetMyFoods {
  myFoods: IMyFood[]
  getMyFoodsLoading: boolean
  getMyFoodsFailed: any
}

export interface ICreateFoodState {
  createFoodLoading: boolean
  createFoodSuccess?: IMyFood
  createFoodFailed: any
}

export interface IUpdateFoodState {
  updateFoodLoading: boolean
  updateFoodSuccess?: IMyFood
  updateFoodFailed: any
}

export interface IFoodDetailsState {
  foodDetails?: IMyFood
  getFoodDetailsLoading: boolean
  getFoodDetailsFailed: any
  detailsBackPath?: string
}

export interface IDeleteFoodState {
  deleteFoodLoading: boolean
  deleteFoodSuccess?: string
  deleteFoodFailed: any
}

export interface IRecentIngredientsState {
  recentIngredients: RecentIngredientType[]
  getRecentIngredientsLoading: boolean
  getRecentIngredientsFailed: any
  isNoRecentIngredients: boolean
  recentIngredientsPage: number
  hasMoreRecentIngredients: boolean

  createRecentIngredientLoading: boolean
  createRecentIngredientSuccess?: RecentIngredientType
  createRecentIngredientFailed: any

  deleteRecentIngredientLoading: boolean
  deleteRecentIngredientSuccess?: string
  deleteRecentIngredientFailed: any
}

export enum ISearchFoodOverlayDisplaySection {
  AUTOCOMPLETE = "AUTOCOMPLETE",
  SEARCH_RESULTS = "SEARCH_RESULTS",
}

export interface IFoodState
  extends IGetSuggestedSearchTexts,
    ISearchFoods,
    IGetMyFoods,
    ICreateFoodState,
    IFoodDetailsState,
    IGetExternalSuggestedSearchTexts,
    ISearchEdamaFoods,
    IUpdateFoodState,
    IDeleteFoodState,
    IRecentIngredientsState {
  isSearchInAddMealPageVisible: boolean
  searchFoodOverlayDisplaySection: ISearchFoodOverlayDisplaySection
}

export type FavoriteMealsContextType = {
  favoriteMeals: MealType[]
  getFavoriteMealsLoading: boolean
  isNoFavoriteMeals: boolean
  hasMoreFavoriteMeals: boolean
  loadMoreFavoriteMeals: () => Promise<any>

  favoriteMealsScrollTop: number
  setFavoriteMealsScrollTop: (top: number) => void
  favoriteMealsContentRef: React.RefObject<HTMLDivElement>
}
